import React, { FunctionComponent, MouseEventHandler } from 'react';

import classnames from 'classnames';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import 'common/chrome/left-nav/nav-toggle/NavToggle.scss';

interface Props {
    isNavOpen: boolean;
    onNavToggle: MouseEventHandler;
}

export const NavToggle: FunctionComponent<Props> = ({ isNavOpen, onNavToggle }) => {
    const toggleClassnames = classnames({
        'icon-angle-left': isNavOpen,
        'icon-angle-right': !isNavOpen,
    });
    const { t } = useTranslation('common/chrome');

    return (
        <Button
            aria-label={t('TOGGLE_SIDE_NAV_BAR')}
            className="r4e-left-nav-toggle"
            variant="action"
            onClick={onNavToggle}
        >
            <i className={toggleClassnames} />
        </Button>
    );
};
